import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import SolicitudComponent from './SolicitudComponent';
import estilos from './SolicitudComponent.module.css'
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import SolicitudFC09Component from './SolicitudFC09Component';

function SolicitudesFC09Component(props) {


    const dispatch = useDispatch()

    const [cajaBusqueda, setCajaBusqueda] = React.useState('');

    const [aux, setAux] = React.useState([]);

    let solicitudesAux = [];

    const [checkPendientes, setCheckPendientes] = React.useState(true);
    const [checkInformeEmitido, setCheckInformeEmitido] = React.useState(false);
    const [checkInformeEnRevision, setCheckInformeEnRevision] = React.useState(false);
    const [checkDictamenEmitido, setCheckDictamenEmitido] = React.useState(false);
    const [checkCompletadas, setCheckCompletadas] = React.useState(false);
    const [checkRechazadas, setCheckRechazadas] = React.useState(false);

    const handleCheckPendientes = () => {
        if (checkPendientes) { setCheckPendientes(false); }
        else { setCheckPendientes(true); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckInfoEmitido = () => {
        if (checkInformeEmitido) { setCheckInformeEmitido(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(true); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckInformeEnRevision = () => {
        if (checkInformeEnRevision) { setCheckInformeEnRevision(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(true); setCheckRechazadas(false); }
    };
    const handleCheckDictamenEmitido = () => {
        if (checkDictamenEmitido) { setCheckDictamenEmitido(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(true); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckCompletadas = () => {
        if (checkCompletadas) { setCheckCompletadas(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(true); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckRechazadas = () => {
        if (checkRechazadas) { setCheckRechazadas(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(true); }
    };

    const handleBuscarInstalaciones = (event) => {
        setCajaBusqueda(event.target.value);
    }

    React.useEffect(() => {

        solicitudesAux = props.solicitudes.filter((solicitud) => {
            if (
                solicitud.nombrecliente?.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase()) ||
                solicitud.folio?.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase())) {
                return solicitud;
            }
        });


        // checkPendientes ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 1 || solicitud.solicitudesuifc01[0]?.statusdelasolicitud == undefined) : null;
        // checkInformeEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 2) : null;
        // checkInformeEnRevision ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 3) : null;
        // checkDictamenEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 4) : null;
        // checkCompletadas ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 5) : null;
        // checkRechazadas ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 6) : null;
        setAux(solicitudesAux)
    }, [cajaBusqueda, checkPendientes, checkInformeEmitido, checkDictamenEmitido, checkCompletadas, props.solicitudes])

    return (
        <>

            {/* CAJA DE BUSQUEDA  */}
            {/* <div className='row' style={{ marginLeft: '10%' }}>
                <div className='col-2'>
                    <div className="form-check" style={{ display: 'inline-block !important' }}>
                        <input className="form-check-input" type="checkbox" checked={checkPendientes} onChange={handleCheckPendientes}>
                        </input>
                        <label className="form-check-label">
                            Pendientes
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkInformeEmitido} onChange={handleCheckInfoEmitido}>
                        </input>
                        <label className="form-check-label">
                            Informe emitido
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkInformeEnRevision} onChange={handleCheckInformeEnRevision}>
                        </input>
                        <label className="form-check-label">
                            Informe en revisión
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkDictamenEmitido} onChange={handleCheckDictamenEmitido}>
                        </input>
                        <label className="form-check-label">
                            Dictámen emitido
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkCompletadas} onChange={handleCheckCompletadas}>
                        </input>
                        <label className="form-check-label">
                            Completadas
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkRechazadas} onChange={handleCheckRechazadas}>
                        </input>
                        <label className="form-check-label">
                            Rechazadas
                        </label>
                    </div>
                </div>
            </div> */}


            <input className='form-control' type='text' placeholder='Ingrese el nombre de la razón social, numero de solicitud o inspector' onChange={handleBuscarInstalaciones} value={cajaBusqueda}></input> <br /><hr />
            <div className={`${estilos.labelUI} row mb-2`}>
                {
                    props.tipo == 9 ?
                        <label className={`${estilos.labelUI} mb-2`}>FC-09 DICTAMEN DE CUMPLIMIENTO CON LA NOM PARA PRODUCTO DE EXPORTACIÓN:</label>
                        :
                        props.tipo == 30 ?
                            <label className={`${estilos.labelUI} mb-2`}>FC-33:</label>
                            :
                            props.tipo == 31 ?
                                <label className={`${estilos.labelUI} mb-2`}>FC-31:</label>
                                :
                                props.tipo == 34 ?
                                    <label className={`${estilos.labelUI} mb-2`}>FC-34:</label>
                                    :
                                    props.tipo == 35 ?
                                        <label className={`${estilos.labelUI} mb-2`}>FC-35:</label>
                                        :
                                        props.tipo == 36 ?
                                            <label className={`${estilos.labelUI} mb-2`}>FC-36:</label>
                                            :
                                            props.tipo == 41 ?
                                                <label className={`${estilos.labelUI} mb-2`}>FC-41:</label>
                                                :
                                                ""

                }
            </div>
            {
                aux.map((s, index) => (
                    <SolicitudFC09Component key={index} solicitud={s} tipo={props.tipo} />
                ))
            }
            <hr></hr>
        </>
    );
}

export default withRouter(SolicitudesFC09Component)